// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".4b645b5e177caec9e51ec21b22eb6d37.js";
};